import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Minibar from '../../../components/navbar/Minibar.js';
import './SiteInfo.css'

function Document(props) {
    const [data_uioption, setData_uioption] = useState({});

    useEffect(() => {
        if (props.data_uioption !== null) {
            if (props.data_uioption.device_selector !== null && props.data_uioption.device_selector !== undefined) {
                setData_uioption(props.data_uioption)
            }
        }
    }, [props.data_uioption]);;

    function get_panel_area() {
        if (data_uioption !== null && data_uioption !== undefined) {
            if (data_uioption.factor_area !== null && data_uioption.factor_area !== undefined) {
                return data_uioption.factor_area.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
        }
        return "-"
    }

    function get_site_capacity() {
        if (data_uioption !== null && data_uioption !== undefined) {
            if (data_uioption.capacity !== null && data_uioption.capacity !== undefined) {
                return data_uioption.capacity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
        }
        return "-"
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <section id="content" className="content">
            <Minibar
                main_root={"Plant"}
                submenu_root={"Site Information"}
                systemtime={props.data_systemdatetime}
            />
            <div className="content__boxed d-md-flex h-100">
                <div className="content__wrap order-2 flex-fill min-w-0">
                    <div id="page-content">
                        <div className="panel">
                            <div className="panel-body">
                                <div className="row mb-2">
                                    <div className="col-xl-12">
                                        <div className='d-flex justify-content-between'>
                                            <div>
                                                <h4 className="mb-1"><i className="mdi mdi-factory color-orange"></i> Site Information</h4>
                                                <p className="mb-1">Local site information</p>
                                            </div>
                                            <div>
                                                {BackCenter()}
                                            </div>
                                        </div>
                                        <hr className="new-section-xs mb-2" />
                                    </div>
                                </div>

                                <div className='d-flex siteinfo-box'>
                                    <div className='siteinfo-left'>
                                        <h5 className='siteinfo-name'>Site Code</h5>
                                        <h6 className='siteinfo-data'>{data_uioption.sitecode_txt}</h6>
                                        <h5 className='siteinfo-name'>Site Name EN</h5>
                                        <h6 className='siteinfo-data'>{data_uioption.sitename_en}</h6>
                                        <h5 className='siteinfo-name'>Site Name TH</h5>
                                        <h6 className='siteinfo-data'>{data_uioption.sitename_th}</h6>
                                        <h5 className='siteinfo-name'>Site Address</h5>
                                        <h6 className='siteinfo-data'>{data_uioption.siteaddress}</h6>
                                        <h5 className='siteinfo-name'>Site Capacity</h5>
                                        <h6 className='siteinfo-data'>{get_site_capacity()} kWp</h6>
                                        <h5 className='siteinfo-name'>Site Panel Area</h5>
                                        <h6 className='siteinfo-data'>{get_panel_area()} m<sup>2</sup></h6>
                                        <h5 className='siteinfo-name'>Solar Type</h5>
                                        <h6 className='siteinfo-data'>{data_uioption.solar_type}</h6>
                                        <h5 className='siteinfo-name'>COD Date</h5>
                                        <h6 className='siteinfo-data'>{moment(new Date(data_uioption.cod_date)).format("DD-MMM-YYYY")}</h6>
                                        <h5 className='siteinfo-name'>Customer Billing Name</h5>
                                        <h6 className='siteinfo-data'>{data_uioption.billing_customer}</h6>
                                        <h5 className='siteinfo-name'>Customer Billing Address</h5>
                                        <h6 className='siteinfo-data'>{data_uioption.billing_address}</h6>
                                        <h5 className='siteinfo-name'>GPS</h5>
                                        <h6 className='siteinfo-data'>{data_uioption.gps_xy}</h6>
                                        <h5 className='siteinfo-name'>Type of Tariff</h5>
                                        <h6 className='siteinfo-data'>{data_uioption.tariff_txt}</h6>
                                    </div>
                                    <div className='d-none d-xl-flex siteinfo-right'>
                                        {
                                            data_uioption.site_img_key !== undefined ?
                                                <img className='siteinfo-img' src={process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/files/reader?key=" + data_uioption.site_img_key + "&&pathdir=config&&filename=site_img_" + props.permitdata.sitecode + ".png"} alt='siteinfo' />
                                                :
                                                null
                                        }
                                    </div>
                                </div>
                                <hr></hr>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}
export default Document